const ROUTE_NAMES = {
  HOME: 'HOME',
  CACHE_TOKEN: 'CACHE_TOKEN',
  PEDIDOS_REPORT: 'PEDIDOS_REPORT',
  PRODUTOS_REPORT: 'PRODUTOS_REPORT',
  CONSUMO_REPORT: 'CONSUMO_REPORT',
}

export default ROUTE_NAMES
